module.exports = __webpack_public_path__ + "static/img/1.c280fce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/mobile/sky101/1.png
// module id = CftB
// module chunks = 1